import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Label } from '../../entities/label/label';
import { CommandService, Reloadable } from '../../services/command/command.service';
import { TableLazyLoadEvent } from 'primeng/table';
import { ApolloService } from '../../services/apollo.service';
import * as fromGraphQl from './graphql';
import { debounceTime, distinctUntilChanged, map, Subject, Subscription, take } from 'rxjs';
import { LabelFilter } from '../../entities/label/label-filter';
import { SortDirection } from '../../entities/sort/sort';

@Component({
  selector: 'app-label-list',
  templateUrl: './label-list.component.html',
  styleUrls: ['./label-list.component.scss']
})
export class LabelListComponent implements OnInit, OnDestroy, Reloadable, OnDestroy {
  public labels: Label[];
  public totalElements: number = 0;
  public pageNumber = 0;
  public pageSize = 15;
  private filterText$ = new Subject<string>();
  private textInputSubscription: Subscription;
  public sortOptions = [
    { label: 'Absteigend', direction: "asc"},
    { label: 'Aufsteigend', direction: "desc" }
  ];
  public sortModel = this.sortOptions[0];
  public sortDirection: SortDirection = this.sortOptions[0].direction as SortDirection;
  text: string;
  public loading = false;

  constructor(
    private router: Router,
    private apolloService: ApolloService,
    private commandService: CommandService
  ) {}

  ngOnInit(): void {
    this.textInputSubscription = this.filterText$.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(text => {
      this.text = text;
      this.loadData();
    });
    this.loadData();
  }

  ngOnDestroy(): void {
    this.textInputSubscription?.unsubscribe();
  }

  reload(): void {
    this.loadData();
  }

  loadData(){
    this.loading = true;
    this.apolloService.query<fromGraphQl.GetLabelsPagedResponse>(
      fromGraphQl.GET_LABELS_PAGED_QUERY,
      {
        filter: this.buildFilter(),
        commandInputs: [
          { "name": "labelDeleteCommand" },
          { "name": "labelUpdateCommand" }
        ]
      })
      .pipe(
        take(1),
        map(response => {
          console.log(response?.data);
          this.labels = Label.createLabels(response?.data?.getLabelsPaged?.content);
          this.totalElements = response?.data?.getLabelsPaged?.totalElements ?? 0;
          this.pageNumber = response?.data?.getLabelsPaged?.number ?? 0;
          this.pageSize = response?.data?.getLabelsPaged?.size ?? 15;
          this.loading = false;
        })
      ).subscribe();
  }

  buildFilter(): LabelFilter {
    const filter = new LabelFilter(
      undefined,
      undefined,
      this.text,
      undefined,
      this.sortDirection,
      this.pageNumber,
      this.pageSize
    );
    filter.sortRequest.sortProperties = undefined;
    return filter;
  }

  onPageChange(event: any) {
    this.pageNumber = Math.floor(event.first / event.rows);
    this.pageSize = event.rows;
    this.loadData();
  }

  editLabel(label: Label) {
    let commandTemplate = label.commands?.find(cmd => cmd.name === 'labelUpdateCommand');
    console.log(commandTemplate);
    this.commandService.execute(label, commandTemplate, this);
  }

  deleteLabel(label: Label) {
    let commandTemplate = label.commands?.find(cmd => cmd.name === 'labelDeleteCommand');
    console.log(commandTemplate);
    this.commandService.execute(label, commandTemplate, this);
  }

  sort(event: any) {
    this.sortDirection = event.value.direction;
    this.loadData();
  }

  filterByText(text: string) {
    this.filterText$.next(text);
  }
}
